import { render, staticRenderFns } from "./check-orders-list.vue?vue&type=template&id=1a4c4e94&scoped=true&"
import script from "./check-orders-list.vue?vue&type=script&lang=js&"
export * from "./check-orders-list.vue?vue&type=script&lang=js&"
import style0 from "./check-orders-list.vue?vue&type=style&index=0&id=1a4c4e94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4c4e94",
  null
  
)

export default component.exports